export default "__VITE_ASSET__5c4f1e89__"